export const tabIndices = {
    fieldData: 0,
    nonFieldData: 1,
    baseData: 2,
};
